module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Bold-c8d0ed25e6e2a459947c880a169330b9.ttf";